import ALERT from '../actions/alert'

const initialState = {
  alert: {},
}

const getters = {
  siteAlert: state => state.alert,
}

const actions = {
  [ALERT.SHOW]: ({ commit }, alert) => {
    commit(ALERT.SHOW, alert)
  },
}

const mutations = {
  [ALERT.SHOW]: (state, alert) => {
    state.alert = alert
  },
}

export default {
  state: initialState,
  getters,
  actions,
  mutations,
}
